
import { BackendModel, BackendService } from '../core/backend.service';
import { CategoriaProducto } from './categoria-producto/categoria-producto.model';
import { SubcategoriaProducto } from './subcategoria-producto/subcategoria-producto.model';
import { Proveedor } from './proveedor/proveedor.model';
import { Imagen } from './imagen.model';
import { MedidasProducto } from './medidas-producto.model';
import { Parametric } from '../cliente/parametric.model';
import { Sugerencia } from './sugerencia/sugerencia.model';
import { OperationalParametric } from '../cliente/operationalParametric.model';
import { Cliente } from '../cliente/cliente.model';
import { Talle } from './talle/talle.model';
import { TipoImpresion } from './tipo-impresion/tipo-impresion.model';
import { Tarifario } from '../acuerdo/tarifario.model';
import { Color } from './color/color.model';
import { EstadoProducto } from './estadoProducto.model';

export class Producto extends BackendModel {

  static origenInterno = 'VIACOTONE';
  static origenExterno = 'DIFAPRO';
  static path = '/productos/';
  static newPath = '/new-productos/';

  prueba: string = "prueba";
  estadoProducto: EstadoProducto;
  sku: string;
  nombre: string;
  detalle: string;
  categorias: CategoriaProducto[];
  subcategorias: SubcategoriaProducto[];
  sugerencias: Sugerencia[];
  proveedor: Proveedor;
  cliente: Cliente;
  descripcion: string;
  imagenes: Imagen[];
  imagenesPersonalizables: Imagen[];
  activo: string;
  colores: Color[];
  medidas: MedidasProducto;
  talles: Talle[];
  tallesNumericos: OperationalParametric[];
  tiposImpresion: TipoImpresion[];
  tarifario: Tarifario;
  precio:number;
  precioFinal:number;
  pais: string;
  destacado: boolean;
  
  comentarioVerificacion: String;
  
  

  constructor(protected backendService: BackendService, model?: Producto) {
    super(backendService, model);
  }

  get categoriasInternas() {
    return this.categorias.filter(s => s.origen === Producto.origenInterno);
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/producto.model.ts